import { toPlatePlugin } from '@udecode/plate/react';

import { BaseBlockquotePlugin } from '../lib/BaseBlockquotePlugin';

export const BlockquotePlugin = toPlatePlugin(BaseBlockquotePlugin);
